import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "ui-textarea__required"
}
const _hoisted_3 = ["id", "value", "placeholder", "disabled", "readonly", "required", "rows", "maxlength"]
const _hoisted_4 = {
  key: 1,
  class: "ui-textarea__footer"
}
const _hoisted_5 = { class: "ui-textarea__helper" }
const _hoisted_6 = {
  key: 0,
  class: "ui-textarea__error"
}
const _hoisted_7 = {
  key: 1,
  class: "ui-textarea__helper-text"
}
const _hoisted_8 = {
  key: 0,
  class: "ui-textarea__char-count"
}

import { computed, ref } from "vue";
import type { Size } from "./types";

interface Props {
  modelValue?: string;
  label?: string;
  placeholder?: string;
  size?: Size;
  rows?: number;
  disabled?: boolean;
  readonly?: boolean;
  required?: boolean;
  error?: string;
  helperText?: string;
  maxLength?: number;
  showCharCount?: boolean;
  resize?: "none" | "vertical" | "horizontal" | "both";
  id?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Textarea',
  props: {
    modelValue: {},
    label: {},
    placeholder: {},
    size: { default: "md" },
    rows: { default: 4 },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    error: {},
    helperText: {},
    maxLength: {},
    showCharCount: { type: Boolean, default: false },
    resize: { default: "vertical" },
    id: {}
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isFocused = ref(false);
const textareaId = computed(
  () => props.id || `textarea-${Math.random().toString(36).substr(2, 9)}`
);

const characterCount = computed(() => props.modelValue?.length || 0);

const wrapperClasses = computed(() => {
  const classes = ["ui-textarea"];
  classes.push(`ui-textarea--${props.size}`);
  if (props.disabled) classes.push("ui-textarea--disabled");
  if (props.error) classes.push("ui-textarea--error");
  return classes;
});

const textareaClasses = computed(() => {
  const classes = ["ui-textarea__field"];
  if (isFocused.value) classes.push("ui-textarea__field--focused");
  classes.push(`ui-textarea__field--resize-${props.resize}`);
  return classes;
});

const handleInput = (event: Event) => {
  const target = event.target as HTMLTextAreaElement;
  emit("update:modelValue", target.value);
};

const handleBlur = (event: FocusEvent) => {
  isFocused.value = false;
  emit("blur", event);
};

const handleFocus = (event: FocusEvent) => {
  isFocused.value = true;
  emit("focus", event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(wrapperClasses.value)
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: textareaId.value,
          class: "ui-textarea__label"
        }, [
          _createTextVNode(_toDisplayString(__props.label) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("textarea", {
      id: textareaId.value,
      value: __props.modelValue,
      placeholder: __props.placeholder,
      disabled: __props.disabled,
      readonly: __props.readonly,
      required: __props.required,
      rows: __props.rows,
      maxlength: __props.maxLength,
      class: _normalizeClass(textareaClasses.value),
      onInput: handleInput,
      onBlur: handleBlur,
      onFocus: handleFocus
    }, null, 42, _hoisted_3),
    (__props.error || __props.helperText || __props.showCharCount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (__props.error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.error), 1))
              : (__props.helperText)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    (__props.showCharCount && __props.maxLength)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(characterCount.value) + " / " + _toDisplayString(__props.maxLength) + " - " + _toDisplayString(__props.helperText), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(__props.helperText), 1)
                        ], 64))
                  ]))
                : _createCommentVNode("", true)
          ]),
          (__props.showCharCount && __props.maxLength && !__props.helperText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(characterCount.value) + " / " + _toDisplayString(__props.maxLength), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})